var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTickSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "zsu8a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 20V0h20v20z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#zsu8a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4bb543",
    d: "M8.957 13.543c-.116.115-.28.212-.424.212-.144 0-.307-.101-.427-.217l-2.693-2.692.856-.856 2.27 2.27 6-6.044.84.87zM10.5 0C4.976 0 .5 4.476.5 10s4.476 10 10 10 10-4.476 10-10-4.476-10-10-10z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickSmall);
export default __webpack_public_path__ + "static/media/green-tick-small.2d082cc5fac1477ba9ef4ebd26288760.svg";
export { ForwardRef as ReactComponent };